<div class="ui container" style="padding-top: 20px">
  <div class="ui one column container grid">
    <div class="column">
      <table class="ui table">
        <thead>
          <tr>
            <th>Booking Id</th>
            <th>Start Date</th>
            <th>Ad</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of approvals; let itemIndex = index">
            <td>
              {{ approval.id }}
            </td>
            <td>
              {{ approval.startDate.seconds * 1000 | date: 'dd MMM yyyy' }}
            </td>
            <td>
              <a href="{{ approval.adUrl }}">
                {{ approval.advertisementId }}
              </a>
            </td>
            <td>
              <div
                class="ui teal labeled icon button"
                (click)="approve(itemIndex)"
              >
                <i class="thumbs up outline icon"></i>
                Approve
              </div>
            </td>
            <td>
              <div
                class="ui red labeled icon button"
                (click)="approve(itemIndex)"
              >
                <i class="thumbs down outline icon"></i>
                Reject
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="ui warning message"
        *ngIf="!approvals || approvals.length === 0"
      >
        No requests for approval
      </div>
    </div>
  </div>
</div>
